import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["icon"];
import React, { forwardRef } from 'react';
import EzIconMui from '../EzIconMui/EzIconMui';
var EzIconFontAwesome = forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
    props = _objectWithoutProperties(_ref, _excluded);
  var _icon$icon = _slicedToArray(icon.icon, 5),
    width = _icon$icon[0],
    height = _icon$icon[1],
    _ligatures = _icon$icon[2],
    _unicode = _icon$icon[3],
    svgPathData = _icon$icon[4];
  return React.createElement(EzIconMui, _extends({
    ref: ref,
    viewBox: "0 0 ".concat(width, " ").concat(height)
  }, props), typeof svgPathData === 'string' ? React.createElement("path", {
    d: svgPathData
  }) : svgPathData.map(function (d, i) {
    return React.createElement("path", {
      key: d,
      style: {
        opacity: i === 0 ? 0.4 : 1
      },
      d: d
    });
  }));
});
EzIconFontAwesome.displayName = 'EzIconFontAwesome';
export default EzIconFontAwesome;